import { useStore } from "@stores";
import { useEffect } from "react";

/**
 * Fetches the soonest upcoming booking each time `enabled` flips true.
 * Backed by an observable on bookingStore — components rerender reactively
 * via mobx when the value changes.
 */
export const useNextBooking = (enabled: boolean) => {
  const { bookingStore, authStore } = useStore();

  useEffect(() => {
    if (!authStore.currentUserId) {
      bookingStore.clearNextBooking();
      return;
    }
    if (!enabled) return;
    bookingStore.getNextBooking();
  }, [enabled, authStore.currentUserId, bookingStore]);

  return {
    nextBooking: bookingStore.nextBooking,
    loading: bookingStore.nextBookingLoading,
  };
};
